import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './components/Auth/AuthProvider';
import DobCollectionGate from './components/Auth/DobCollectionGate';
import PrivateRoute from './components/Auth/PrivateRoute';
import LoginPage from './pages/LoginPage';
import VideoPage from './pages/VideoPage';
import RegisterPage from './pages/RegisterPage';
import VideoDetailsPage from './pages/VideoDetailsPage';
import DashboardPage from './pages/DashboardPage';
import PaymentCancelled from './pages/PaymentCancelled';
import Landing from './pages/Landing';
import CreateDiscountCode from './components/discountCode/CreateDiscountCode';
import EditDiscountCode from './components/discountCode/EditDiscountCode';
import Unauthorized from './components/Unauthorized';
import { theme } from './components/common/theme';
import { ThemeProvider } from 'styled-components';
import Layout from './components/common/Layout';
import AuthLayout from './components/common/AuthLayout';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import VerifyEmail from './components/VerifyEmail';
import Contact from './components/Contact';
import VideoTrimmerWrapper from './components/Video/VideoTrimmerWrapper';
import CookiePolicy from './components/policies/CookiePolicy';
import TermsOfService from './components/policies/TermsOfService';
import ReturnPolicy from './components/policies/ReturnPolicy';
import PrivacyPolicy from './components/policies/PrivacyPolicy';
import Disclaimer from './components/policies/Disclaimer';
import TermsOfServicee from './components/TermsOfService';
import PrivacyPolicyy from './components/PrivacyPolicy';
import TikTokLoginButton from './components/TikTokLoginButton';
import TikTokShare from './components/TikTokShare';
import PaymentSuccess from './components/PaymentSuccess';
import PaymentCancel from './components/PaymentCancel';
import OwnerPaymentSuccess from './components/OwnerPaymentSuccess';
import LivestreamManagement from './components/livestreams/LivestreamManagement';
import LivestreamWatchPage from './components/livestreams/LivestreamWatchPage';
import AdminDashboard from '../src/components/Dashboard/adminDashboard/AdminDashboard.js';
import ScoreBoard from './components/livestreams/ScoreBoard';
import PricingPage from './pages/PricingPage';
import ManageSubscriptionPage from './pages/ManageSubscriptionPage';
import AdminFeatureFlagsPage from './pages/AdminFeatureFlagsPage';
import AdminPlansPage from './pages/AdminPlansPage';
import { CourtDashboardPage } from './components/courtManagement';
import { UserProfilePage, UserSearchComponent } from './components/profile';
import ConnectionDiagnostic from './components/ConnectionDiagnostic';
import { ToastContainer } from 'react-toastify';
import './styles/App.css';
import 'react-toastify/dist/ReactToastify.css';

const App = () => (
  <AuthProvider>
    <DobCollectionGate />
    <ThemeProvider theme={theme}> 
      <Router>
      <Routes>
  {/* Public Routes */}
      <Route path="/" element={<Landing />} />
      <Route 
            path="/register" 
            element={
              <AuthLayout headerProps={registerPropHeaderObject} logoSrc="/1.svg">
                <RegisterPage />
              </AuthLayout>
            } 
          />
      {/* Public Routes without Navbar */}
      <Route 
            path="/login" 
            element={
              <AuthLayout headerProps={loginPropHeaderObject} logoSrc="/1.svg">
                <LoginPage />
              </AuthLayout>
            } 
          />
      <Route path="/all-livestream-events" element={
        <Layout>
          <LivestreamManagement />
        </Layout>
      } />
      <Route path="/livestreams" element={
        <Layout>
          <LivestreamManagement />
        </Layout>
      } />
      <Route path="/livestream/watch/:livestreamId" element={
        <Layout>
          <LivestreamWatchPage />
        </Layout>
      } />
      <Route path="/public/livestream/watch/:livestreamId" element={
        <Layout>
          <LivestreamWatchPage />
        </Layout>
      } />
      <Route path="/livestream/watch" element={
        <Layout>
          <LivestreamWatchPage />
        </Layout>
      } />
      <Route path="/livestream/score/:livestreamId" element={
        <PrivateRoute>
          <Layout>
            <ScoreBoard />
          </Layout>
        </PrivateRoute>
      } />
      <Route path = "/payment-success" element={<PaymentSuccess />} />
      <Route path = "/payment-cancel" element={<PaymentCancel />} />
      <Route path="/owner/livestreams/:livestreamId/checkout/success" element={<OwnerPaymentSuccess />} />
      <Route path="/schedule/live" element={<Layout><LivestreamManagement /></Layout>} />
      <Route path="/unauthorized" element={<Unauthorized />} />
      <Route path="/tiktok/login" element={<AuthLayout><TikTokLoginButton /> </AuthLayout>} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/verify-email" element={<VerifyEmail />} />
      <Route path="/tiktok/share" element={<Layout><TikTokShare /></Layout>} />
      <Route path="/explore" element={<Layout><VideoPage /></Layout>} />
      <Route path="/video/:id" element={<VideoDetailsPage />} />
      <Route path="/payment-cancelled" element={<PaymentCancelled />} />
      <Route path="/contact" element={<Layout><Contact /></Layout>} />
      <Route path="/privacy-policy" element={<Layout><PrivacyPolicy/></Layout>} />
        <Route path="/cookie-policy" element={<Layout><CookiePolicy/></Layout>} />
        <Route path="/terms-of-service" element={<Layout><TermsOfService/></Layout>} />
        <Route path="/terms-of-servicee" element={<Layout><TermsOfServicee/></Layout>} />
        <Route path="/return-policy" element={<Layout><ReturnPolicy/></Layout>} />
        <Route path="/disclaimer" element={<Layout><Disclaimer/></Layout>} />
        <Route path="/privacy-policyy" element={<Layout><PrivacyPolicyy/></Layout>} />

  {/* Protected Routes */}
  <Route
    path="/dashboard/*"
    element={
      <PrivateRoute>
        <Layout>
        <DashboardPage />
        </Layout>
      </PrivateRoute>
    }
  />
  <Route 
  path="/videos/:videoId/trim" 
  element={
    <PrivateRoute>
      <Layout>
      <VideoTrimmerWrapper />
      </Layout>
    </PrivateRoute>
  } />
    <Route
    path="/admin/dashboard"
    element={
      <PrivateRoute requiredRole="ADMIN">
        <Layout>
        <AdminDashboard />
        </Layout>
      </PrivateRoute>
    }
  />
      <Route
    path="/admin/discount-code/create"
    element={
      <PrivateRoute requiredRole="ADMIN">
        <Layout>
        <CreateDiscountCode />
        </Layout>
      </PrivateRoute>
    }
  />

<Route
    path="/admin/discount-code/update/:id"
    element={
      <PrivateRoute requiredRole="ADMIN">
        <Layout>
        <EditDiscountCode />
        </Layout>
      </PrivateRoute>
    }
  />

        <Route path="/court-management" element={
          <PrivateRoute requiredRole="SITE_OWNER">
            <Layout>
              <CourtDashboardPage />
            </Layout>
          </PrivateRoute>
        } />
      <Route path="/subscription" element={<Layout><PricingPage /></Layout>} />
      <Route path="/pricing" element={<Layout><PricingPage /></Layout>} />
      <Route path="/account/subscription" element={
        <PrivateRoute>
          <Layout>
            <ManageSubscriptionPage />
          </Layout>
        </PrivateRoute>
      } />

      {/* User Profile Routes */}
      <Route path="/profile" element={
        <PrivateRoute>
          <Layout>
            <UserProfilePage />
          </Layout>
        </PrivateRoute>
      } />
      <Route path="/search-users" element={
        <PrivateRoute requiredRole="ADMIN">
          <Layout>
            <UserSearchComponent />
          </Layout>
        </PrivateRoute>
      } />
      
      {/* Admin Subscription Routes */}
      <Route path="/admin/subscriptions/features" element={
        <PrivateRoute requiredRole="ADMIN">
          <Layout>
            <AdminFeatureFlagsPage />
          </Layout>
        </PrivateRoute>
      } />
      <Route path="/admin/subscriptions/plans" element={
        <PrivateRoute requiredRole="ADMIN">
          <Layout>
            <AdminPlansPage />
          </Layout>
        </PrivateRoute>
      } />

  {/* Add this new route for handling confirmation redirects */}
  <Route 
    path="/confirmation" 
    element={
      <Navigate to="/explore" replace />
    } 
  />

</Routes>

      </Router>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <ConnectionDiagnostic />
    </ThemeProvider>

  </AuthProvider>
);

export default App;

const loginPropHeaderObject = {
  altText: 'Logo',
  title: 'Welcome back!',
  subtitle: 'Login to your account to continue.',
};

const registerPropHeaderObject = {
  altText: 'Logo',
  title: 'Create an account',
  subtitle: 'to access your videos',
};
